import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  id: "modal_arming",
  class: "modal fade show",
  tabindex: "-1",
  "data-backdrop": "static"
}
const _hoisted_3 = { class: "modal-dialog modal-sm" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header justify-content-center text-center" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "font-italic font-weight-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "modal-body d-flex flex-column align-items-center p-3" }
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { class: "mt-3 font-size-lg float-right" }
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Zu den Einstellungen")
], -1)
const _hoisted_17 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "mr-3 position-relative" }
const _hoisted_20 = {
  key: 0,
  class: "icon-exclamation position-absolute right-0 bg-danger text-white rounded-circle"
}
const _hoisted_21 = { class: "media-body" }
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger font-size-xs"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", { class: "list-icons-item" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_25 = {
  key: 0,
  class: "media bg-light font-weight-semibold py-2"
}
const _hoisted_26 = { class: "mr-2 mr-lg-3 d-flex flex-column align-items-center" }
const _hoisted_27 = { class: "btn bg-transparent rounded-pill border-2 btn-icon border-success" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "d-flex flex-column align-items-start" }
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { class: "d-flex flex-row align-items-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["id"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "mr-2 mr-lg-3 d-flex flex-column align-items-center" }
const _hoisted_37 = { class: "btn bg-transparent rounded-pill border-2 btn-icon border-success" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, null, -1)
const _hoisted_39 = { class: "media-body align-self-center" }
const _hoisted_40 = { class: "d-flex flex-column" }
const _hoisted_41 = { class: "text-muted" }
const _hoisted_42 = { class: "ml-3" }
const _hoisted_43 = { class: "list-icons" }
const _hoisted_44 = {
  key: 0,
  class: "ml-lg-3 mt-3 mt-lg-1"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell-on" }, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell-slash" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "list-icons-item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CounterCircle = _resolveComponent("CounterCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.armingSystem), 1),
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CounterCircle, {
              size: 200,
              max: parseInt(_ctx.armingTimeStart),
              count: parseInt(_ctx.armingTime),
              value: _ctx.armingTime,
              unit: 'sekunden',
              prefix: 'wird in',
              suffix: _ctx.armingText+' geschalten'
            }, null, 8, ["max", "count", "value", "suffix"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, "Versuch: " + _toDisplayString(_ctx.tryArmingCounter) + " / 2", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.objectStreet) + " " + _toDisplayString(_ctx.objectHouseNumber) + " | " + _toDisplayString(_ctx.objectZip) + " " + _toDisplayString(_ctx.objectCity), 1),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("ul", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, tabIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: tabIndex }, [
            (!tab.items && tab.visibility)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass({'disabled':tab.disabled})
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["media cursor-pointer align-items-center", {'disabled':tab.disabled}]),
                    onClick: ($event: any) => (_ctx.showDetails(tab.pathName))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", tab.class])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(tab.icon)
                        }, null, 2)
                      ], 2),
                      (tab.errors !== null)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createTextVNode(_toDisplayString(tab.headline) + " ", 1),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(tab.text), 1),
                      (tab.errors !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Fehler in dieser Anlage"))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_24
                  ], 10, _hoisted_18)
                ], 2))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (tab.visibility)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("a", _hoisted_27, [
                            _createElementVNode("i", {
                              class: _normalizeClass([tab.icon, "text-success"])
                            }, null, 2)
                          ])
                        ]),
                        _createElementVNode("a", {
                          class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
                          href: '#collapse-icon'+tabIndex,
                          "data-toggle": "collapse"
                        }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createTextVNode(_toDisplayString(tab.headline) + " ", 1),
                            _createElementVNode("small", _hoisted_30, _toDisplayString(tab.text), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                              class: "text-body",
                              "data-toggle": "collapse",
                              "aria-expanded": "false"
                            }, _hoisted_33)
                          ])
                        ], 8, _hoisted_28)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "collapse",
                    id: 'collapse-icon'+tabIndex
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.items, (subTab, subIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: subIndex,
                        class: "bg-light"
                      }, [
                        _createElementVNode("a", {
                          class: "media cursor-pointer align-items-center",
                          onClick: ($event: any) => (_ctx.showDetails(subTab.pathName, subTab.pathParams))
                        }, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("a", _hoisted_37, [
                              _createElementVNode("i", {
                                class: _normalizeClass([subTab.icon, "text-success"])
                              }, null, 2)
                            ]),
                            _hoisted_38
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createTextVNode(_toDisplayString(subTab.headline) + " ", 1),
                              _createElementVNode("span", _hoisted_41, _toDisplayString(subTab.text), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              (tabIndex === 'systems')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (subTab.args.switchManually && subTab.args.armingBySystem && _ctx.user.rights.arming?.write)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                          (subTab.args.eventState == 100)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                type: "button",
                                                class: "btn bg-danger-800 btn-sm w-100 w-lg-auto",
                                                onClick: _withModifiers(($event: any) => (_ctx.setArming(subTab.args, true, subTab.args.anlage_id)), ["stop"])
                                              }, [
                                                _hoisted_46,
                                                _createTextVNode(" " + _toDisplayString(subTab.args.isTypeHikvision ? 'Unterer Schwellwert an' : 'scharf schalten'), 1)
                                              ], 8, _hoisted_45))
                                            : (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                type: "button",
                                                class: "btn btn-primary text-white btn-sm w-100 w-lg-auto",
                                                onClick: _withModifiers(($event: any) => (_ctx.setArming(subTab.args, false, subTab.args.anlage_id)), ["stop"])
                                              }, [
                                                _hoisted_48,
                                                _createTextVNode(" " + _toDisplayString(subTab.args.isTypeHikvision ?  'Unterer Schwellwert aus' : 'unscharf schalten'), 1)
                                              ], 8, _hoisted_47))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _hoisted_49
                            ])
                          ])
                        ], 8, _hoisted_35)
                      ]))
                    }), 128))
                  ], 8, _hoisted_34)
                ], 64))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}